// extracted by mini-css-extract-plugin
module.exports = {"standard":"standard__VCr44","disabled":"disabled__Cx20A","input":"input__PgMQp","label":"label__5LJ9o"};